import { useEffect, useState } from 'react';
import { AUTO_HIDE_CHANGED_EVENT, readAutoHideDiscussionPanel } from './fileReviewUiPrefs';

const AUTO_HIDE_STORAGE_PREFIX = 'jarvis.fileReview.autoHideDiscussionPanel';

export function useAutoHideDiscussionPanel(): boolean {
  const [autoHide, setAutoHide] = useState(() => readAutoHideDiscussionPanel());

  useEffect(() => {
    const sync = () => setAutoHide(readAutoHideDiscussionPanel());
    const onStorage = (event: StorageEvent) => {
      if (!event.key || !event.key.startsWith(AUTO_HIDE_STORAGE_PREFIX)) return;
      sync();
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener(AUTO_HIDE_CHANGED_EVENT, sync);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(AUTO_HIDE_CHANGED_EVENT, sync);
    };
  }, []);

  return autoHide;
}
